import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "events-svg-fill",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M21.424 3.711h-1.14V2.58a.78.78 0 0 0-.788-.773.78.78 0 0 0-.787.773v1.133h-5.872V2.579a.78.78 0 0 0-.787-.773.78.78 0 0 0-.787.773v1.133H5.39V2.579a.78.78 0 0 0-.787-.773.78.78 0 0 0-.786.773v1.133H2.676c-.732 0-1.326.583-1.326 1.303v1.838h21.4V5.015c0-.72-.595-1.304-1.326-1.304zM1.35 21.096c0 .718.594 1.302 1.325 1.302h18.75c.73 0 1.325-.584 1.325-1.302V8.091H1.35zm15.228-10.862h3.315v3.259h-3.315zm0 5.925h3.315v3.261h-3.315zm-6.186-5.925h3.314v3.259h-3.314zm0 5.925h3.314v3.261h-3.314zm-6.187-5.925h3.316v3.259H4.205zm0 5.925h3.316v3.261H4.205z"
    }, null, -1)
  ])))
}
export default { render: render }